import { Box } from '@mui/material';
import { Node } from '@tiptap/pm/model';
import { Editor, NodeViewWrapper } from '@tiptap/react';
import { useCallback, useRef } from 'react';

interface ImageBlockViewProps {
  editor: Editor;
  getPos: () => number;
  node: Node;
  updateAttributes: (attrs: Record<string, string>) => void;
}

export const ImageBlockView = (props: ImageBlockViewProps) => {
  const { editor, getPos, node } = props as ImageBlockViewProps & {
    node: Node & {
      attrs: {
        src: string;
      };
    };
  };
  const imageWrapperRef = useRef<HTMLDivElement>(null);
  const { src } = node.attrs;

  // Define alignment styles for Material UI Box
  const getAlignmentStyle = () => {
    switch (node.attrs.align) {
      case 'left':
        return { marginLeft: 0, marginRight: 'auto' };
      case 'right':
        return { marginLeft: 'auto', marginRight: 0 };
      case 'center':
      default:
        return { marginLeft: 'auto', marginRight: 'auto' };
    }
  };

  const onClick = useCallback(() => {
    editor.commands.setNodeSelection(getPos());
  }, [getPos, editor.commands]);

  return (
    <NodeViewWrapper>
      <Box
        sx={{
          width: node.attrs.width,
          ...getAlignmentStyle(),
        }}
        data-drag-handle
      >
        <Box ref={imageWrapperRef} contentEditable={false}>
          <Box
            component='img'
            src={src}
            alt=''
            onClick={onClick}
            sx={{ display: 'block' }}
          />
        </Box>
      </Box>
    </NodeViewWrapper>
  );
};

export default ImageBlockView;
